module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "name": "tab13-popup",
      "id": "tab13-popup",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header header-popup"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.labels['STD_SKILSC']['10']) + " ()")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('hrms-table', {
    attrs: {
      "columns": _vm.tab13PopupColumn,
      "data": _vm.detailTab13Popup
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-06102b79!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres31x/tab13Popup.vue
// module id = 3516
// module chunks = 1